import { DCBaseGamepadButtonEvent } from "./DCBaseGamepadButtonEvent.js";
export class DCGamepadDownEvent extends DCBaseGamepadButtonEvent {
    eventType = "gamepad-botton-down";
    inputType = "gamepad-button";
    constructor() {
        super();
    }
}
